import { FC, HTMLAttributes } from 'react';

export const DraftCalendarIcon: FC<HTMLAttributes<SVGSVGElement>> = props => (
  <svg width="40" height="28" viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.4 4.13635H27.35V2.16666H25.25V4.13635H14.75V2.16666H12.65V4.13635H11.6C10.445 4.13635 9.5 5.02272 9.5 6.10605V21.8636C9.5 22.947 10.445 23.8333 11.6 23.8333H28.4C29.555 23.8333 30.5 22.947 30.5 21.8636V6.10605C30.5 5.02272 29.555 4.13635 28.4 4.13635ZM28.4 21.8636H11.6V9.0606H28.4V21.8636Z"
      fill="#666666"
    />
    <path
      d="M25.1041 16.5208H20.7291V20.5833H19.2708V16.5208H14.8958V15.1667H19.2708V11.1042H20.7291V15.1667H25.1041V16.5208Z"
      fill="#666666"
    />
  </svg>
);
